/* eslint-disable import/no-anonymous-default-export */

import OtherArticlesListPage from "../../views/OtherArticlesListPage";
import {
    GET_ALL_ARTICLES,
    GET_ALL_ARTICLES_UPDATED,
    GET_ALL_ARTICLES_TAG,
    // GET_ALL_ADVERTISEMENTS_PAGE,
    ALL_ARTICLES_ERROR,
    GET_ARTICLE,
    GET_MARKETING_COUNT,
    GET_MARKETING_COUNT_ERROR,
    GET_ARTICLE_ERROR,
    GET_RESEARCH_ARTICLES_PAGINATED,
    GET_CASE_STUDY_ARTICLES_PAGINATED,
    GET_RESEARCH_ARTICLES_PAGINATED_ERROR,
    GET_ARTICLE_COUNT,
    GET_ARTICLE_COUNT_ERROR,
    GET_PODCASTS,
    GET_ALL_PODCASTS,
    GET_PODCAST_COUNT,
    ADD_PODCAST,
    UPDATE_PODCAST,
    DELETE_PODCAST,
    SEARCH_PODCAST_PAGE,
    GET_CE,
    GET_CE_COUNT,
    SEARCH_CE_PAGE,
    GET_INFORMATION,
    GET_INFORMATION_COUNT,
    SEARCH_INFORMATION_PAGE,
    GET_OTHER,
    GET_OTHER_COUNT,
    SEARCH_OTHER_PAGE,
    ADD_ARTICLE,
    ADD_ARTICLE_ERROR,
    SEARCH_MARKETING_PAGE,
    UPDATE_ARTICLE,
    DELETE_ARTICLE,
    SELECT_ARTICLE,
    UPDATE_ARTICLE_ERROR,
    DELETE_ARTICLE_ERROR,
    // GET_ALL_ADVERTISEMENTS_PAGE_ERROR,
    GET_FEATURED_ARTICLES,
    GET_FEATURED_ARTICLES_ERROR,
    GET_CASE_STUDY_ARTICLES_PAGINATED_ERROR,
    SET_FEATURED_ARTICLE,
    SET_FEATURED_ARTICLE_ERROR,
    SET_FEATURED_ARTICLES_FALSE,
    SET_FEATURED_ARTICLES_FALSE_ERROR,
    GET_MARKETING_MATERIALS_ARTICLES_PAGINATED,
    GET_MARKETING_MATERIALS_ARTICLES_PAGINATED_ERROR,
    SEARCH_MARKETING_PAGE_ERROR,
    GET_FEATURED_EBOOKS,
    SET_FEATURED_EBOOK,
    SET_FEATURED_EBOOKS_FALSE,
    GET_FEATURED_EBOOKS_ERROR,
    SET_FEATURED_EBOOK_ERROR,
    SET_FEATURED_EBOOKS_FALSE_ERROR,
    GET_PODCASTS_ERROR,
    GET_ALL_PODCASTS_ERROR,
    GET_PODCAST_COUNT_ERROR,
    ADD_PODCAST_ERROR,
    UPDATE_PODCAST_ERROR,
    DELETE_PODCAST_ERROR,
    SEARCH_PODCAST_PAGE_ERROR,
    GET_CE_ERROR,
    GET_CE_COUNT_ERROR,
    SEARCH_CE_PAGE_ERROR,
    GET_INFORMATION_ERROR,
    GET_INFORMATION_COUNT_ERROR,
    SEARCH_INFORMATION_PAGE_ERROR,
    GET_OTHER_ERROR,
    GET_OTHER_COUNT_ERROR,
    SEARCH_OTHER_PAGE_ERROR,
    GET_ARTICLE_PRODUCTS,
    GET_ARTICLE_PRODUCTS_ERROR,
    UPDATE_ARTICLE_PRODUCT_MAP,
    UPDATE_ARTICLE_PRODUCT_MAP_ERROR,
    DELETE_ARTICLE_PRODUCT_ASSOCIATION,
    DELETE_ARTICLE_PRODUCT_ASSOCIATION_ERROR,
    GET_EBOOKS,
    GET_EBOOKS_ERROR,
    SEARCH_ALL_ARTICLES_PAGE,
    SEARCH_ALL_ARTICLES_PAGE_ERROR,
    UNPUBLISH_ARTICLES,
    UNPUBLISH_ARTICLES_ERROR,
    GET_ALL_FEATURED_RECENT_ARTICLES,
    GET_FEATURED_RECENT_ARTICLES_BY_CATEGORY,
    DELETE_FEATURED_RECENT_ARTICLES,
    ADD_FEATURED_RECENT_ARTICLE,
    GET_ALL_FEATURED_RECENT_ARTICLES_ERROR,
    GET_FEATURED_RECENT_ARTICLES_BY_CATEGORY_ERROR,
    DELETE_FEATURED_RECENT_ARTICLES_ERROR,
    ADD_FEATURED_RECENT_ARTICLE_ERROR,
    GET_ALL_URL_TITLES,
    SEARCH_PUBLISHED_ARTICLES,
    SEARCH_PUBLISHED_ARTICLES_ERROR,
    SET_CASE_STUDY_LIST_IS_LOADING_TRUE,
    GET_CASE_STUDIES_COUNT,
    GET_CASE_STUDIES_COUNT_ERROR,
    SEARCH_CASE_STUDIES_PAGINATED,
    SEARCH_CASE_STUDIES_PAGINATED_ERROR,
    SEARCH_CASE_STUDIES_COUNT,
    SEARCH_CASE_STUDIES_COUNT_ERROR,
    SET_RESEARCH_LIST_IS_LOADING_TRUE,
    GET_RESEARCH_ARTICLES_COUNT,
    GET_RESEARCH_ARTICLES_COUNT_ERROR,
    SEARCH_RESEARCH_ARTICLES_PAGINATED,
    SEARCH_RESEARCH_ARTICLES_PAGINATED_ERROR,
    SEARCH_RESEARCH_ARTICLES_COUNT,
    SEARCH_RESEARCH_ARTICLES_COUNT_ERROR,
    SET_MARKETING_MATERIALS_LIST_IS_LOADING_TRUE,
    GET_MARKETING_MATERIALS_SEARCH_COUNT,
    GET_MARKETING_MATERIALS_SEARCH_COUNT_ERROR,
    SET_PODCAST_LIST_IS_LOADING_TRUE,
    GET_PODCAST_SEARCH_COUNT,
    GET_PODCAST_SEARCH_COUNT_ERROR,
    SET_CE_LIST_IS_LOADING_TRUE,
    SEARCH_CE_COUNT,
    SEARCH_CE_COUNT_ERROR,
    SET_INFO_ARTICLES_LIST_IS_LOADING_TRUE,
    GET_INFO_ARTICLES_SEARCH_COUNT,
    GET_INFO_ARTICLES_SEARCH_COUNT_ERROR,
    SET_OTHER_ARTICLES_LIST_IS_LOADING_TRUE,
    GET_OTHER_ARTICLES_SEARCH_COUNT,
    GET_OTHER_ARTICLES_SEARCH_COUNT_ERROR,
    GET_CASE_STUDIES_MANUFACTURERS,
    GET_CASE_STUDIES_MANUFACTURERS_ERROR,



    SET_ARTICLES_LIST_IS_LOADING_TRUE,
    GET_ARTICLES_MANUFACTURERS_FOR_FILTERS,
    GET_ARTICLES_MANUFACTURERS_FOR_FILTERS_ERROR,
    GET_ALL_ARTICLES_PAGINATED_BY_TYPE,
    GET_ALL_ARTICLES_PAGINATED_BY_TYPE_ERROR,
    GET_ALL_ARTICLES_COUNT_BY_TYPE,
    GET_ALL_ARTICLES_COUNT_BY_TYPE_ERROR,
    SEARCH_ARTICLES_PAGINATED_BY_TYPE,
    SEARCH_ARTICLES_PAGINATED_BY_TYPE_ERROR,
    SEARCH_ARTICLES_COUNT_BY_TYPE,
    SEARCH_ARTICLES_COUNT_BY_TYPE_ERROR,
    REMOVE_HOME_PAGE_FEATURED_EBOOK,
    REMOVE_HOME_PAGE_FEATURED_EBOOK_ERROR,

} from "../actions/types";

const initialState = {
    articles: [],
    publishedArticles: [],
    articlesUpdated: [],
    articleProducts: [],
    allFeaturedRecentArticles: [],
    featuredRecentArticlesByCategory: [],
    blogs: [],
    ebooks: [],
    
    allArticleSearch: [],
    
    podcasts: [],
    
    
    

    
    
    
    
    
    featuredNewArticles: [],
    selectedArticle: [],
    featuredEbooks: [],
    allUrlTitles: [],
    article: null,
    isLoading: true,
    success: false,
    count: null,


    // USED IN NEW STAND ALONE DPS CMS
    isLoadingCaseStudyList: true,
    caseStudiesPaginated: [],
    caseStudiesCount: null,
    caseStudySearchPaginated: [],
    caseStudySearchCount: null,
    isLoadingResearchList: true,
    researchArticlesPaginated: [],
    researchArticlesCount: null,
    researchArticlesSearchPaginated: [],
    researchArticlesSearchCount: null,
    isLoadingMarketingMaterialsList: true,
    marketingMaterialsPaginated: [],
    marketingMaterialsCount: null,
    marketingMaterialsSearchPaginated: [],
    marketingMaterialsSearchCount: null,
    isLoadingPodcastsList: true,
    podcastsPaginated: [],
    podcastsCount: null,
    podcastSearchPaginated: [],
    podcastSearchCount: null,
    isLoadingCEList: true,
    contEducationPaginated: [],
    contEducationCount: null,
    contEducationSearchPaginated: [],
    contEducationSearchCount: null,
    isLoadingInfoArticlesList: true,
    infoArticlesPaginated: [],
    infoArticlesCount: null,
    infoArticlesSearchPaginated: [],
    infoArticlesSearchCount: null,
    isLoadingOtherArticlesList: true,
    otherArticlesPaginated: [],
    otherArticlesCount: null,
    otherArticlesSearchPaginated: [],
    otherArticlesSearchCount: null,
    caseStudiesManufacturers: [],



    isLoadingArticleList: true,
    articleManufacturersForFilter:[],
    articlesPaginatesbyType:[],
    allArticlesCountByType: null,
    searchArticlesPaginatedByType:[],
    searchArticlesCountByType: null,

};

export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {

        case SET_ARTICLES_LIST_IS_LOADING_TRUE:
            return {
                ...state,
                isLoadingArticleList: true,
                success: true,
            };
        case GET_ALL_ARTICLES_PAGINATED_BY_TYPE:
            return {
                ...state,
                articlesPaginatesbyType: payload,
                isLoadingArticleList: false,
                success: true,
            };

        case GET_ALL_ARTICLES_PAGINATED_BY_TYPE_ERROR:
            return {
                ...state,
                articlesPaginatesbyType: payload,
                isLoadingArticleList: false,
                success: true,
            };
        case GET_ALL_ARTICLES_COUNT_BY_TYPE:
            return {
                ...state,
                allArticlesCountByType: payload,
                isLoadingArticleList: false,
                success: false,
            };
        case GET_ALL_ARTICLES_COUNT_BY_TYPE_ERROR:
            return {
                ...state,
                allArticlesCountByType: payload,
                isLoadingArticleList: false,
                success: false,
            };
        case GET_ARTICLES_MANUFACTURERS_FOR_FILTERS:
            return {
                ...state,
                articleManufacturersForFilter: payload,
                isLoadingArticleList: false,
                success: true,
            };

        case GET_ARTICLES_MANUFACTURERS_FOR_FILTERS_ERROR:
            return {
                ...state,
                articleManufacturersForFilter: payload,
                isLoadingArticleList: false,
                success: true,
            };
        case SEARCH_ARTICLES_PAGINATED_BY_TYPE:
            return {
                ...state,
                searchArticlesPaginatedByType: payload,
                isLoadingArticleList: false,
                success: true,
            };
        case SEARCH_ARTICLES_PAGINATED_BY_TYPE_ERROR:
            return {
                ...state,
                searchArticlesPaginatedByType: payload,
                isLoadingArticleList: false,
                success: true,
            };
        case SEARCH_ARTICLES_COUNT_BY_TYPE:
            return {
                ...state,
                searchArticlesCountByType: payload,
                isLoadingArticleList: false,
                success: false,
            };
        case SEARCH_ARTICLES_COUNT_BY_TYPE_ERROR:
            return {
                ...state,
                searchArticlesCountByType: payload,
                isLoadingArticleList: false,
                success: false,
            };
        
            










    
        case SET_OTHER_ARTICLES_LIST_IS_LOADING_TRUE:
            return {
                ...state,
                isLoadingOtherArticlesList: true,
                success: true,
            };

        case GET_CASE_STUDIES_MANUFACTURERS:
            return {
                ...state,
                caseStudiesManufacturers: payload,
                success: true,
            };
        case GET_OTHER:
            return {
                ...state,
                otherArticlesPaginated: payload,
                isLoading: false,
                isLoadingOtherArticlesList: false,
                success: true,
            };
        case GET_OTHER_ERROR:
            return {
                ...state,
                otherArticlesPaginated: payload,
                isLoading: false,
                isLoadingOtherArticlesList: false,
                success: false,
            };
        case GET_OTHER_COUNT:
            return {
                ...state,
                otherArticlesCount: payload,
                isLoading: false,
                success: false,
            };
        case GET_OTHER_COUNT_ERROR:
            return {
                ...state,
                otherArticlesCount: payload,
                isLoading: false,
                success: false,
            };
        case SEARCH_OTHER_PAGE:
            return {
                ...state,
                otherArticlesSearchPaginated: payload,
                isLoadingOtherArticlesList: false,
                isLoading: false,
                success: true,
            };
        case SEARCH_OTHER_PAGE_ERROR:
            return {
                ...state,
                otherArticlesSearchPaginated: payload,
                isLoadingOtherArticlesList: false,
                isLoading: false,
                success: true,
            };
        case GET_OTHER_ARTICLES_SEARCH_COUNT:
            return {
                ...state,
                otherArticlesSearchCount: payload,
                isLoading: false,
                success: false,
            };
        case GET_OTHER_ARTICLES_SEARCH_COUNT_ERROR:
            return {
                ...state,
                otherArticlesSearchCount: payload,
                isLoading: false,
                success: false,
            };






        case SET_INFO_ARTICLES_LIST_IS_LOADING_TRUE:
            return {
                ...state,
                isLoadingInfoArticlesList: true,
                success: true,
            };
        case GET_INFORMATION:
            return {
                ...state,
                infoArticlesPaginated: payload,
                isLoading: false,
                isLoadingInfoArticlesList: false,
                success: true,
            };
        case GET_INFORMATION_ERROR:
            return {
                ...state,
                infoArticlesPaginated: payload,
                isLoading: false,
                isLoadingInfoArticlesList: false,
                success: false,
            };
            case GET_INFORMATION_COUNT:
                return {
                    ...state,
                    infoArticlesCount: payload,
                    isLoading: false,
                    success: false,
                };
            case GET_INFORMATION_COUNT_ERROR:
                return {
                    ...state,
                    infoArticlesCount: payload,
                    isLoading: false,
                    success: false,
                };
            case SEARCH_INFORMATION_PAGE:
                return {
                    ...state,
                    infoArticlesSearchPaginated: payload,
                    isLoadingInfoArticlesList: false,
                    isLoading: false,
                    success: true,
                };
            case SEARCH_INFORMATION_PAGE_ERROR:
                return {
                    ...state,
                    infoArticlesSearchPaginated: payload,
                    isLoadingInfoArticlesList: false,
                    isLoading: false,
                    success: true,
                };
            case GET_INFO_ARTICLES_SEARCH_COUNT:
                return {
                    ...state,
                    infoArticlesSearchCount: payload,
                    isLoading: false,
                    success: true,
                };
            case GET_INFO_ARTICLES_SEARCH_COUNT_ERROR:
                return {
                    ...state,
                    infoArticlesSearchCount: payload,
                    isLoading: false,
                    success: true,
                };






        case SET_CE_LIST_IS_LOADING_TRUE:
            return {
                ...state,
                isLoadingCEList: true,
                success: true,
            };
        
        case GET_CE:
            return {
                ...state,
                contEducationPaginated: payload,
                isLoading: false,
                isLoadingCEList: false,
                success: true,
            };

        case GET_CE_ERROR:
            return {
                ...state,
                contEducationPaginated: payload,
                isLoading: false,
                isLoadingCEList: false,
                success: false,
            };
        case GET_CE_COUNT:
            return {
                ...state,
                contEducationCount: payload,
                isLoading: false,
                success: false,
            };
        case GET_CE_COUNT_ERROR:
            return {
                ...state,
                contEducationCount: payload,
                isLoading: false,
                success: false,
            };
        case SEARCH_CE_PAGE:
            return {
                ...state,
                contEducationSearchPaginated: payload,
                isLoading: false,
                isLoadingCEList: false,
                success: true,
            };
        case SEARCH_CE_PAGE_ERROR:
            return {
                ...state,
                contEducationSearchPaginated: payload,
                isLoading: false,
                isLoadingCEList: false,
                success: true,
            };
        case SEARCH_CE_COUNT:
            return {
                ...state,
                contEducationSearchCount: payload,
                isLoading: false,
                success: false,
            };
        case SEARCH_CE_COUNT_ERROR:
            return {
                ...state,
                S: payload,
                isLoading: false,
                success: false,
            };




        case SET_PODCAST_LIST_IS_LOADING_TRUE:
            return {
                ...state,
                isLoadingPodcastsList: true,
                success: true,
            };

        case GET_PODCASTS:
            return {
                ...state,
                podcastsPaginated: payload,
                isLoading: false,
                isLoadingPodcastsList: false,
                success: true,
            };

        case GET_PODCASTS_ERROR:
            return {
                ...state,
                podcastsPaginated: payload,
                isLoading: false,
                isLoadingPodcastsList: false,
                success: false,
            };

        case GET_PODCAST_COUNT:
            return {
                ...state,
                podcastsCount: payload,
                isLoading: false,
                success: true,
            };

        case GET_PODCAST_COUNT_ERROR:
            return {
                ...state,
                podcastCount: payload,
                isLoading: false,
                success: false,
            };

        case SEARCH_PODCAST_PAGE:
            return {
                ...state,
                podcastSearchPaginated: payload,
                isLoadingPodcastsList: false,
                isLoading: false,
                success: true,
            };

        case SEARCH_PODCAST_PAGE_ERROR:
            return {
                ...state,
                podcastSearchPaginated: payload,
                isLoadingPodcastsList: false,
                isLoading: false,
                success: true,
            };

        case GET_PODCAST_SEARCH_COUNT:
            return {
                ...state,
                podcastSearchCount: payload,
                isLoading: false,
                success: true,
            };

        case GET_PODCAST_SEARCH_COUNT_ERROR:
            return {
                ...state,
                podcastSearchCount: payload,
                isLoading: false,
                success: false,
            };







        case SET_MARKETING_MATERIALS_LIST_IS_LOADING_TRUE:
            return {
                ...state,
                isLoadingMarketingMaterialsList: true,
                success: true,
            };
        
        case GET_MARKETING_MATERIALS_ARTICLES_PAGINATED:
            return {
                ...state,
                marketingMaterialsPaginated: payload,
                isLoading: false,
                isLoadingMarketingMaterialsList: false,
                success: true,
            };

        case GET_MARKETING_MATERIALS_ARTICLES_PAGINATED_ERROR:
            return {
                ...state,
                marketingMaterialsPaginated: payload,
                isLoading: false,
                isLoadingMarketingMaterialsList: false,
                success: false,
            };
        
        case GET_MARKETING_COUNT:
            return {
                ...state,
                marketingMaterialsCount: payload,
                isLoading: false,
                success: true,
            };

        case GET_MARKETING_COUNT_ERROR:
            return {
                ...state,
                marketingMaterialsCount: payload,
                isLoading: false,
                success: false,
            };

        case SEARCH_MARKETING_PAGE:
            return {
                ...state,
                marketingMaterialsSearchPaginated: payload,
                // marketingMaterialsSearchCount: payload.count,
                isLoading: false,
                isLoadingMarketingMaterialsList: false,
                success: true,
            };

        case SEARCH_MARKETING_PAGE_ERROR:
            return {
                ...state,
                marketingMaterialsSearchPaginated: payload,
                // marketingMaterialsSearchCount: payload.count,
                isLoading: false,
                isLoadingMarketingMaterialsList: false,
                success: true,
            };

        case GET_MARKETING_MATERIALS_SEARCH_COUNT:
            return {
                ...state,
                marketingMaterialsSearchCount: payload,
                isLoading: false,
                success: true,
            };

        case GET_MARKETING_MATERIALS_SEARCH_COUNT_ERROR:
            return {
                ...state,
                marketingMaterialsSearchCount: payload,
                isLoading: false,
                success: true,
            };








        case SET_RESEARCH_LIST_IS_LOADING_TRUE:
            return {
                ...state,
                isLoadingResearchList: true,
                success: true,
            };

        case SEARCH_RESEARCH_ARTICLES_PAGINATED:
            return {
                ...state,
                researchArticlesSearchPaginated: payload,
                isLoading: false,
                isLoadingResearchList: false,
                success: true,
            };

        case SEARCH_RESEARCH_ARTICLES_PAGINATED_ERROR:
            return {
                ...state,
                researchArticlesSearchPaginated: payload,
                isLoading: false,
                isLoadingResearchList: false,
                success: false,
            };

        case SEARCH_RESEARCH_ARTICLES_COUNT:
            return {
                ...state,
                researchArticlesSearchCount: payload,
                isLoading: false,
                success: true,
            };

        case SEARCH_RESEARCH_ARTICLES_COUNT_ERROR:
            return {
                ...state,
                researchArticlesSearchCount: payload,
                isLoading: false,
                success: false,
            };

        case GET_RESEARCH_ARTICLES_PAGINATED:
            return {
                ...state,
                researchArticlesPaginated: payload,
                isLoading: false,
                isLoadingResearchList: false,
                success: true,
            };

        case GET_RESEARCH_ARTICLES_PAGINATED_ERROR:
            return {
                ...state,
                researchArticlesPaginated: payload,
                isLoading: false,
                isLoadingResearchList: false,
                success: false,
            };

        case GET_RESEARCH_ARTICLES_COUNT:
            return {
                ...state,
                researchArticlesCount: payload,
                isLoading: false,
                success: true,
            };

        case GET_RESEARCH_ARTICLES_COUNT_ERROR:
            return {
                ...state,
                researchArticlesCount: payload,
                isLoading: false,
                success: false,
            };






        case SET_CASE_STUDY_LIST_IS_LOADING_TRUE:
            return {
                ...state,
                isLoadingCaseStudyList: true,
                success: true,
            };

        case GET_CASE_STUDY_ARTICLES_PAGINATED:
            return {
                ...state,
                caseStudiesPaginated: payload,
                isLoading: false,
                isLoadingCaseStudyList: false,
                success: true,
            };

        case GET_CASE_STUDY_ARTICLES_PAGINATED_ERROR:
            return {
                ...state,
                caseStudiesPaginated: payload,
                isLoading: false,
                isLoadingCaseStudyList: false,
                success: false,
            };

        case GET_CASE_STUDIES_COUNT:
            return {
                ...state,
                caseStudiesCount: payload,
                isLoading: false,
                success: true,
            };

        case GET_CASE_STUDIES_COUNT_ERROR:
            return {
                ...state,
                caseStudiesCount: payload,
                isLoading: false,
                success: false,
            };

        case SEARCH_CASE_STUDIES_PAGINATED:
            return {
                ...state,
                caseStudySearchPaginated: payload,                
                isLoading: false,
                isLoadingCaseStudyList: false,
                success: true,
            };

        case SEARCH_CASE_STUDIES_PAGINATED_ERROR:
            return {
                ...state,
                caseStudySearchPaginated: payload,                
                isLoading: false,
                isLoadingCaseStudyList: false,
                success: true,
            };

        case SEARCH_CASE_STUDIES_COUNT:
            return {
                ...state,
                caseStudySearchCount: payload,
                isLoading: false,
                success: true,
            };

        case SEARCH_CASE_STUDIES_COUNT_ERROR:
            return {
                ...state,
                caseStudySearchCount: payload,
                isLoading: false,
                success: true,
            };





        // case GET_ALL_ADVERTISEMENTS_PAGE:
        case GET_ALL_ARTICLES:
            return {
                ...state,
                articles: payload,
                blogs: payload.filter((item) => item.article_type === "Blogs"),
                ebooks: payload.filter((item) => item.article_type === "eBook"),
                evaluatedProducts: payload.filter(
                    (item) => item.article_type === "Product Evaluation"
                ),
                content: payload.filter(
                    (item) =>
                        item.article_type === "eBook" || item.article_type === "Content"
                ),
                caseStudiesPaginated: payload.filter((item) => item.article_type === "Case Study"),
                research: payload.filter((item) => item.article_type === "Research"),
                marketingMaterialsPaginated: payload.filter(
                    (item) => item.article_type === "Marketing Materials"
                ),
                videos: payload.filter((item) => item.article_type === "Videos"),
                isLoading: false,
                success: true,
            };
        case GET_ALL_ARTICLES_TAG:
            return {
                ...state,
                articles: payload,
                blogs: payload.filter((item) => item.article_type === "Blogs"),
                ebooks: payload.filter((item) => item.article_type === "eBook"),
                evaluatedProducts: payload.filter(
                    (item) => item.article_type === "Product Evaluation"
                ),
                content: payload.filter(
                    (item) =>
                        item.article_type === "eBook" || item.article_type === "Content"
                ),
                caseStudiesPaginated: payload.filter((item) => item.article_type === "Case Study"),
                research: payload.filter((item) => item.article_type === "Research"),
                marketingMaterialsPaginated: payload.filter(
                    (item) => item.article_type === "Marketing Materials"
                ),
                videos: payload.filter((item) => item.article_type === "Videos"),
                isLoading: false,
                success: true,
            };
        case SEARCH_ALL_ARTICLES_PAGE:
            return {
                ...state,
                allArticleSearch: payload,
                isLoading: false,
                success: true,
            };
        case SEARCH_PUBLISHED_ARTICLES:
            return {
                ...state,
                publishedArticles: payload,
                isLoading: false,
                success: true,
            };
        case GET_ALL_URL_TITLES:
            return {
                ...state,
                allUrlTitles: payload,
                isLoading: false,
                success: true,
            }
        case GET_ALL_FEATURED_RECENT_ARTICLES:
            return {
                ...state,
                allFeaturedRecentArticles: payload,
                isLoading: false,
                success: true,
            };
        case GET_FEATURED_RECENT_ARTICLES_BY_CATEGORY:
            return {
                ...state,
                featuredRecentArticlesByCategory: payload,
                isLoading: false,
                success: true,
            };
        case GET_EBOOKS:
            return {
                ...state,
                ebooks: payload,
                isLoading: false,
                success: true,
            };
        case GET_ALL_ARTICLES_UPDATED:
            return {
                ...state,
                articlesUpdated: payload
            }
        case GET_ARTICLE:
            return {
                ...state,
                article: payload,
                isLoading: false,
                success: true,
            };
        case GET_ARTICLE_PRODUCTS:
            return {
                ...state,
                articleProducts: payload,
                isLoading: false,
                success: true,
            };
        case GET_FEATURED_ARTICLES:
            return {
                ...state,
                featuredNewArticles: payload,
                isLoading: false,
                success: true,
            };
        case GET_FEATURED_EBOOKS:
            return {
                ...state,
                featuredEbooks: payload,
                isLoading: false,
                success: true,
            };
        case REMOVE_HOME_PAGE_FEATURED_EBOOK:
                return {
                    ...state,
                    isLoading: false,
                    success: true,
                };
        case REMOVE_HOME_PAGE_FEATURED_EBOOK_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
            };
        
        
        case GET_ALL_PODCASTS:
            return {
                ...state,
                podcasts: payload,
                isLoading: false,
                success: true,
            };

        
        
        
        case SELECT_ARTICLE:
            return {
                ...state,
                selectedArticle: payload,
            };
        
        
        
        
        
        
        case UNPUBLISH_ARTICLES:
        case UPDATE_ARTICLE:
        case DELETE_ARTICLE:
        case ADD_ARTICLE:
        case ADD_FEATURED_RECENT_ARTICLE:
        case SET_FEATURED_ARTICLE:
        case SET_FEATURED_ARTICLES_FALSE:
        case SET_FEATURED_EBOOK:
        case SET_FEATURED_EBOOKS_FALSE:
        case UPDATE_ARTICLE_PRODUCT_MAP:
        case DELETE_ARTICLE_PRODUCT_ASSOCIATION:
        case DELETE_FEATURED_RECENT_ARTICLES:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        case SEARCH_ALL_ARTICLES_PAGE_ERROR:
            return {
                ...state,
                allArticleSearch: payload,
                isLoading: false,
                success: false,
            };
        case SEARCH_PUBLISHED_ARTICLES_ERROR:
            return {
                ...state,
                publishedArticles: [],
                isLoading: false,
                success: false,
            };
        // case GET_ALL_ADVERTISEMENTS_PAGE_ERROR:
        case ALL_ARTICLES_ERROR:
            return {
                ...state,
                articles: payload,
                isLoading: false,
                success: false,
            };
        case GET_ARTICLE_PRODUCTS_ERROR:
            return {
                ...state,
                articleProducts: payload,
                isLoading: false,
                success: false,
            };
        case GET_EBOOKS_ERROR:
            return {
                ...state,
                ebooks: payload,
                isLoading: false,
                success: false,
            };
        case UNPUBLISH_ARTICLES_ERROR:
        case DELETE_ARTICLE_ERROR:
        case UPDATE_ARTICLE_ERROR:
        case ADD_ARTICLE_ERROR:
        case ADD_FEATURED_RECENT_ARTICLE_ERROR:
        case SET_FEATURED_ARTICLE_ERROR:
        case SET_FEATURED_ARTICLES_FALSE_ERROR:
        case SET_FEATURED_EBOOK_ERROR:
        case DELETE_PODCAST_ERROR:
        case UPDATE_PODCAST_ERROR:
        case SET_FEATURED_EBOOKS_FALSE_ERROR:
        case UPDATE_ARTICLE_PRODUCT_MAP_ERROR:
        case DELETE_ARTICLE_PRODUCT_ASSOCIATION_ERROR:
        case DELETE_FEATURED_RECENT_ARTICLES_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
            };
        case GET_ARTICLE_ERROR:
            return {
                ...state,
                article: payload,
                isLoading: false,
                success: false,
            };
        case GET_FEATURED_ARTICLES_ERROR:
            return {
                ...state,
                featuredNewArticles: payload,
                isLoading: false,
                success: false,
            };
        case GET_FEATURED_EBOOKS_ERROR:
            return {
                ...state,
                featuredEbooks: payload,
                isLoading: false,
                success: false,
            };
        case GET_ALL_FEATURED_RECENT_ARTICLES_ERROR:
            return {
                ...state,
                allFeaturedRecentArticles: payload,
                isLoading: false,
                success: false,
            };
        case GET_FEATURED_RECENT_ARTICLES_BY_CATEGORY_ERROR:
            return {
                ...state,
                featuredRecentArticlesByCategory: payload,
                isLoading: false,
                success: false,
            };
        case GET_ARTICLE_COUNT_ERROR:
            return {
                ...state,
                count: payload,
                isLoading: false,
                success: false,
            };
        
        
        
        

        case GET_ALL_PODCASTS_ERROR:
            return {
                ...state,
                podcasts: payload,
                isLoading: false,
                success: false,
            };
        // case ADD_PODCAST_ERROR:
        
        
        

        
        
        
        
        
    

        
        default:
            return state;
    }
}
